<template>
  <v-row>
    <v-col cols="12" md="3">
      <form novalidate @submit.prevent="submit">
        <p class="caption">Note: Results will shown in Indian Rupees (INR)</p>
        <v-text-field
          type="number" step="1000"
          v-model="formData.budget"
          @input="renderResults"
          v-validate="'required|numeric'"
          :error-messages="errors.collect('budget')"
          :label="dictionary.attributes.budget"
          data-vv-name="budget"
          required
        ></v-text-field>
        <v-text-field
          type="number" step="1"
          v-model="formData.hoursSpent"
          @input="renderResults"
          v-validate="'required|decimal:1'"
          :error-messages="errors.collect('hoursSpent')"
          :label="dictionary.attributes.hoursSpent"
          data-vv-name="hoursSpent"
          required
        ></v-text-field>
        <v-text-field
          type="number" step="100"
          v-model="formData.hourlyRate"
          @input="renderResults"
          v-validate="'required|numeric'"
          :error-messages="errors.collect('hourlyRate')"
          :label="dictionary.attributes.hourlyRate"
          data-vv-name="hourlyRate"
          required
        ></v-text-field>
        <v-select
          :items="rateValues"
          v-model="formData.hourIncRate"
          @change="renderResults"
          v-validate="'required|numeric'"
          :error-messages="errors.collect('hourIncRate')"
          :label="dictionary.attributes.hourIncRate"
          data-vv-name="hourIncRate"
          required
        ></v-select>
        <v-select
          :items="taxValues"
          v-model="formData.taxPercent"
          @change="renderResults"
          v-validate="'required'"
          :error-messages="errors.collect('taxPercent')"
          :label="dictionary.attributes.taxPercent"
          data-vv-name="taxPercent"
          required
        ></v-select>
        <div class="mt-5 d-flex">
          <v-spacer></v-spacer>
          <span v-if="!saving">
            <v-btn depressed text @click="reset">Reset</v-btn>
            <v-btn depressed color="accent" class="ml-2" type="submit">Calculate</v-btn>
          </span>
          <v-btn depressed color="accent" class="ml-2" disabled v-if="saving">
            <v-progress-circular indeterminate
              size="12" width="1"
              class="mr-1"></v-progress-circular>
            <span>Saving...</span>
          </v-btn>
        </div>
      </form>
    </v-col>
    <v-col cols="12" md="9">
      <v-card tile flat>
        <v-row no-gutters>
          <v-col cols="12" sm="4">
            <v-card tile elevation="0">
              <v-card flat height="120">
                <v-card-text>
                  <h4 class="overline mb-3">Rate Card</h4>
                </v-card-text>
              </v-card>
                <div v-for="(item, key) in resultAttributes"
                    :key="key">
                  <v-divider></v-divider>
                  <v-list-item :two-line="key.startsWith('budget')">
                    <v-list-item-content>
                      <v-list-item-title class="body-2">{{ item }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="2"
            v-for="(group, index) in resultGroups"
            :key="index">
              <v-card tile :elevation="group.active?1:0" height="100%"
              :color="group.active?'light-blue lighten-5':''">
                <v-card tile flat height="120"
                  :dark="group.active"
                  :color="group.active?'accent':''">
                <v-card-text>
                  <h4 class="overline mb-3">{{ group.title }}</h4>
                  <div class="headline font-weight-bold">{{ group.total | currency }}</div>
                  <div>inc. tax {{ group.totalWithTax | currency }}</div>
                </v-card-text>
                </v-card>
                <div v-for="(item, key) in resultAttributes"
                    :key="key">
                  <v-divider></v-divider>
                  <v-list-item :two-line="key.startsWith('budget')">
                    <v-list-item-content>
                      <v-list-item-title v-if="key==='budget'"
                        class="body-2 font-weight-bold"
                        :class="{ 'red--text darken-4': group.exceeding,
                        'green--text darken-4': !group.exceeding }">
                        <span class="caption">
                          {{ group.exceeding ? 'Funds Exceeding' : 'Funds left' }}
                        </span>
                        <div>{{ group.budgetDiff | currency }}</div>
                      </v-list-item-title>
                      <v-list-item-title v-else-if="key==='budgetWithTax'"
                        class="body-2 font-weight-bold"
                        :class="{ 'red--text darken-4': group.exceedingWithTax,
                        'green--text darken-4': !group.exceedingWithTax }">
                        <span class="caption">
                          {{ group.exceeding ? 'Funds Exceeding' : 'Funds left' }}
                        </span>
                        <div>{{ group.budgetDiffWithTax | currency }}</div>
                      </v-list-item-title>
                      <v-list-item-title v-else
                        class="body-2">
                        {{ group[key] || 0 }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-card>
            </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<style scoped>
.elevation-1 {
  z-index: 1;
  /* transform: scale(1.05); */
}
</style>
<script>
export default {
  name: 'effort-estimator-tool',

  $_veeValidate: {
    validator: 'new',
  },

  data: () => ({
    autofocus: true,
    saving: false,
    dictionary: {
      attributes: {
        hoursSpent: 'Hours Spent (ex: 1.2)',
        hourlyRate: 'Hourly Rate (INR)',
        taxPercent: 'Tax Percentage (%)',
        includeTax: 'Include Tax',
        hourIncRate: 'Hourly Rate Increment',
        budget: 'Project Budget',
      },
    },
    taxValues: [5, 10, 15, 20, 25, 30],
    formData: {},
    resultGroups: [
      {
        id: 'result',
        title: 'Your result',
        active: true,
      },
      {
        id: 'suggestion1',
        title: 'Suggestion #1',
      },
      {
        id: 'suggestion2',
        title: 'Suggestion #2',
      },
      {
        id: 'suggestion3',
        title: 'Suggestion #3',
      },
    ],
    resultAttributes: {
      hoursSpent: 'Hours Spent',
      hourlyRate: 'Hourly Rate',
      taxPercent: 'Tax Percentage',
      budget: 'Budget',
      budgetWithTax: 'Budget (inc. tax)',
    },
    formDefaults: {
      hoursSpent: 10,
      hourlyRate: 600,
      includeTax: true,
      taxPercent: 30,
      hourIncRate: 100,
      budget: 100000,
    },
    rateValues: [
      50,
      100,
      150,
      200,
      250,
      300,
      350,
      400,
      450,
      500,
    ],
  }),

  computed: {},

  mounted() {
    this.$validator.localize('en', this.dictionary);
    this.reset();
    this.autofocus = true;
  },

  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.renderResults();
        }
      });
    },
    reset() {
      this.formData = {
        ...this.formDefaults,
      };
      this.clear();
      this.renderResults();
    },
    clear() {
      this.$validator.reset();
    },
    renderResults() {
      const {
        hoursSpent, hourlyRate, taxPercent, hourIncRate,
        budget,
      } = this.formData;

      if (hoursSpent === undefined || hoursSpent === ''
        || hourlyRate === undefined || hourlyRate === '') {
        return;
      }

      let hourlyRateTacker = +this.formData.hourlyRate;

      this.resultGroups.forEach((item, index) => {
        const currentItem = {
          ...item,
        };
        currentItem.hourIncRate = +hourIncRate;
        currentItem.hoursSpent = +hoursSpent;
        currentItem.hourlyRate = +hourlyRateTacker;
        currentItem.taxPercent = +taxPercent;
        currentItem.total = hoursSpent * currentItem.hourlyRate;
        currentItem.totalWithTax = currentItem.total * (100 + currentItem.taxPercent) / 100;
        hourlyRateTacker += currentItem.hourIncRate;
        currentItem.exceeding = currentItem.total > budget;
        currentItem.exceedingWithTax = currentItem.totalWithTax > budget;
        currentItem.budgetDiff = budget - currentItem.total;
        currentItem.budgetDiffWithTax = budget - currentItem.totalWithTax;
        this.$set(this.resultGroups, index, currentItem);
      });
    },
  },
};
</script>
